import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { usePageMeta } from '../hooks/usePageMeta';
import { getNews, isMicroCMSConfigured } from '../lib/microcms';
import { News } from '../types/news';

export const NewsListPage = () => {
  const [newsItems, setNewsItems] = useState<News[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  usePageMeta({
    title: 'News',
    description: 'WAOUHのお知らせや更新情報を掲載しています。',
    path: '/news',
  });

  useEffect(() => {
    const run = async () => {
      try {
        const data = await getNews();
        setNewsItems(data);
      } catch (e) {
        setError('お知らせの取得に失敗しました。microCMSの設定をご確認ください。');
      } finally {
        setLoading(false);
      }
    };

    run();
  }, []);

  return (
    <section>
      <h1 className="page-title">News</h1>
      <p className="section-lead">お知らせや更新情報を掲載します。</p>
      {!isMicroCMSConfigured && <p className="notice">microCMSの設定をご確認ください。</p>}
      {loading && <p className="notice">読み込み中です...</p>}
      {error && <p className="notice notice-error">{error}</p>}

      {!loading && !error && newsItems.length === 0 && (
        <p className="notice">お知らせはまだありません。</p>
      )}

      <div className="news-grid">
        {newsItems.map((item) => (
          <article className="news-card" key={item.id}>
            <div className="news-body">
              <p className="meta">{dayjs(item.publishedAt).format('YYYY.MM.DD')}</p>
              <h2>
                <Link to={`/news/${item.id}`} className="card-title-link">
                  {item.title}
                </Link>
              </h2>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};
